import { cn } from "@/lib/utils";

export function WidgetPlaceholderBody({
  messaggio,
  className,
}: {
  messaggio?: string;
  className?: string;
}) {
  return (
    <p className={cn("text-xs text-muted-foreground italic", className)}>
      {messaggio ??
        "Questo widget non è ancora attivo. Sarà popolato nelle prossime sessioni."}
    </p>
  );
}
